export default "__VITE_ASSET__ded2bca0__"